import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLanguage16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconLanguage16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M1 1.997h9.003V4.2a.503.503 0 0 1-1.006 0V3.003H6.003v7.991h1.063a.503.503 0 0 1 0 1.006H5.554a.5.5 0 0 1-.108 0H3.753a.503.503 0 1 1 0-1.006h1.244V3.003H2.006V4.2A.503.503 0 1 1 1 4.2zm10.262 9.17.397-.265a2.74 2.74 0 0 0 1.218-2.277v-1.62H7.441V6h3.556V4.5a.503.503 0 1 1 1.006 0V6H15v1.006h-1.117v1.62a3.74 3.74 0 0 1-1.586 3.058l1.848.925a.503.503 0 0 1-.45.9l-2.36-1.181L8.8 14.017l-.558-.837 2.072-1.382a3.74 3.74 0 0 1-1.756-3.171V8.4h1.006v.227c0 1.036.586 1.984 1.513 2.447z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLanguage16);
